import React, { useState } from 'react';
import { CartCard } from './CartCard';
import { useSearch } from '../../../store/context/SearchContext';

export const CartList = () => {
  const { productsList } = useSearch();
  const [runUpdate, setRunUpdate] = useState(false);

  // const [theUserProductsList, setTheUserProductsList] = useState([]);
  let theUserProductsList = []
  console.log("from cartList ==========================================000001", productsList);
  productsList.forEach((product) => {
    const existingItem = theUserProductsList.find(item => item.item.p_id === product.p_id);
    if (existingItem) {
      existingItem.units += 1;
    } else {
      theUserProductsList.push({ item: product, units: 1 });

    }
  });
  console.log("from cartList ==========================================000002", theUserProductsList);
  if(runUpdate === false){
  
    console.log("settttttttting" , runUpdate);
    setInterval( ()=> setRunUpdate(true), 50 )
  
  }

  return (
    <div className='min-h-[300px]'>
      {runUpdate ?  <> {theUserProductsList.map((product, index) => (
      
      // <div key={product.p_id}>
      <div key={index}>
          <CartCard setRunUpdate={setRunUpdate} key={product.p_id} initialUnits={product.units} product={product.item} />
       </div>
  
     ))} </> : <> Loading.... </> }
      
     
    </div>
  );
};

